<div class="dialog-header gbg" style="min-width: 255px;">
    <div class="dialog-title fs20">
        {{title}}
    </div>
</div>

<div class="dialog-body" style="min-width: 255px;" [ngClass]="{'xs-dialog-scroll' : size.xs }">

    <div  class="row field-sm">
        <div class="col-md-12">
            <mat-form-field appearance="outline" class="w100 bold" *ngIf="identity.isPrimary === true && identity.isLicence !== true">
                <mat-label>Photo ID Type</mat-label>
                <mat-select (selectionChange)="idTypeChange($event)">
                    <mat-option *ngFor="let item of photoList" [value]="item">
                        <span class="bold">{{item.name}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w100 bold" *ngIf="identity.isPrimary !== true">
                <mat-label>NON Photo ID Type</mat-label>
                <mat-select (selectionChange)="idTypeChange($event)">
                    <mat-option *ngFor="let item of nonPhotoList" [value]="item">
                        <span class="bold">{{item.name}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <ng-container *ngIf="typeId === 1">
        <app-driver-licence-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-driver-licence-form>
    </ng-container>
    <ng-container  *ngIf="typeId === 2">
        <app-passport-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-passport-form>
    </ng-container>
    <ng-container *ngIf="typeId === 3">
        <app-immi-card-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-immi-card-form>
    </ng-container>
    <ng-container *ngIf="typeId === 4">
        <app-birth-certificate-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-birth-certificate-form>
    </ng-container>
    <ng-container *ngIf="typeId === 5">
        <app-centre-link-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-centre-link-form>
    </ng-container>
    <ng-container *ngIf="typeId === 6">
        <app-citizenship-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-citizenship-form>
    </ng-container>
    <ng-container *ngIf="typeId === 7">
        <app-descent-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-descent-form>
    </ng-container>
    <ng-container *ngIf="typeId === 8">
        <app-marriage-certificate-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-marriage-certificate-form>
    </ng-container>
    <ng-container *ngIf="typeId === 9">
        <app-medicare-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-medicare-form>
    </ng-container>
    <ng-container *ngIf="typeId === 10">
        <app-name-change-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-name-change-form>
    </ng-container>
    <ng-container *ngIf="typeId === 11">
        <app-visa-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-visa-form>
    </ng-container>
    <ng-container *ngIf="typeId === 12">
        <app-electoral-roll-form [client]="client" [identity]="identity" [type]="type" [typeId]="typeId" (formSubmitted)="formSubmitted($event)"></app-electoral-roll-form>
    </ng-container>
    
    
</div>

<div class="dialog-footer text-center">
    <button mat-raised-button (click)="close()"><i class="fas fa-times"></i>&nbsp;Close</button>
</div>